<template>
  <div class="app-container" style="padding:30px 100px;">
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <p>
          <el-button :disabled="!disabled" type="primary" @click="disabled = !disabled">编辑信息</el-button>
        </p>
      </el-col>
    </el-row>
    <el-form :model="data" ref="addForm" label-width="100px">
      <el-form-item label="租户名称:">{{data.fullName}}</el-form-item>
      <el-form-item label="租户简称:" prop="name">
        <el-input
          :disabled="disabled"
          type="text"
          :maxlength="6"
          v-model="data.name"
          placeholder="请输入租户简称"
          clearable
          style="width:500px"
        />
      </el-form-item>
      <el-form-item v-if="data.tenantType !== 2" label="分类" prop="tagList">
        <el-checkbox-group v-model="data.tagList" :disabled="disabled">
          <el-checkbox v-for="dict in tenantTagList" :label="dict.dictLabel"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="LOGO:" prop="name">
          <span class="tips-text">请上传1:1的企业LOGO图片</span>
          <div v-if="disabled">
            <el-image
              style="width: 100px; height: 100px;background:#eee;"
              :src="data.companyLogo"
              :preview-src-list="[data.companyLogo]"
              fit="contain"
            />
          </div>
          <FileUploadHeader v-else v-model="fileObjs" :fixedNumber="[1, 1]" :limit="1" :readOnly="disabled" @on-change="handleFileChange" accept="image/gif,image/jpg,image/jpeg,image/png" :autoCropWidth="200" :autoCropHeight="200"></FileUploadHeader>
          <!-- <FileUpload
            v-model="fileObjs"
            :limit="1"
            :readOnly="disabled"
            accept="image/gif,image/jpg,image/jpeg,image/png"
            :autoCropWidth="300"
            :autoCropHeight="200"
            @on-change="handleFileChange"
          ></FileUpload> -->
      </el-form-item>
      <el-form-item label="简介:" prop="introduction">
        <el-input
          :disabled="disabled"
          type="textarea"
          style="width:500px"
          :autosize="{ minRows: 3, maxRows: 5}"
          :maxlength="1000"
          show-word-limit
          v-model="data.introduction"
          placeholder="请输入"
          clearable
        />
      </el-form-item>
      <el-form-item label="联系人:" prop="linkNickName">
        <el-input
          :disabled="disabled"
          type="text"
          :maxlength="30"
          v-model="data.linkNickName"
          placeholder="请输入联系人姓名"
          clearable
          style="width:500px"
        />
      </el-form-item>
      <el-form-item label="联系电话:" prop="linkTel">
        <el-input
          :disabled="disabled"
          type="text"
          :maxlength="30"
          v-model="data.linkTel"
          placeholder="请输入联系电话"
          clearable
          style="width:500px"
        />
      </el-form-item>
      <el-form-item label="联系地址:" prop="term">
        <el-cascader
          :disabled="disabled"
          v-model="data.area"
          :options="areaOptions"
          clearable
          style="width:500px"
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="detailAddress">
        <el-input
          :disabled="disabled"
          type="textarea"
          style="width:500px"
          v-model="data.detailAddress"
          :maxlength="200"
          show-word-limit
          placeholder="请输入详细地址"
          clearable
        />
      </el-form-item>
      <el-form-item v-if="data.specialType === 1" label="官网客服" prop="clueStatus">
        <el-select
          :disabled="disabled"
          v-model="data.customerServiceUserId"
          placeholder="请选择"
          clearable
          style="width:500px"
        >
          <el-option
            v-for="dict in userList"
            :key="dict.userId"
            :label="dict.nickName"
            :value="dict.userId"
          />
        </el-select>
      </el-form-item>

      <el-form-item v-if="!disabled">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import FileUploadHeader from "@/components/CropperFileUpload/CropperFileUpload";
import { transferCascaderOptionsForProvince } from "@/utils";
import { listAllLevelArea } from "@/api/crm/area";
import {
  queryCompanyDetail,
  companyEdit
} from "@/api/saas/package";
import { listUserWithOutDataScope } from "@/api/system/user";

export default {
  components: {
    FileUploadHeader
  },
  data() {
    return {
      disabled: true,
      areaOptions: [],
      staffOptions: [],
      tenantTagList: [],
      userList: [],
      fileObjs: [],
      data: {
        tagList: [],
        cityId: 0,
        companyLogo: '',
        customerServiceUserId: -1,
        detailAddress: '',
        districtId: 0,
        fullName: '',
        introduction: '',
        linkNickName: '',
        linkTel: '',
        name: '',
        provinceId: 0,
        tenantId: 0,
        specialType: 0
      }
    };
  },
  created() {
    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
    this.getDicts("tenant_tag").then(response => {
      this.tenantTagList = response.data;
    });
  },

  mounted() {
    this.queryCompanyDetail()
  },
  methods: {
    listUserWithOutDataScope() {
      listUserWithOutDataScope()
        .then(response => {
          this.userList = response.rows || [];
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    queryCompanyDetail() {
      queryCompanyDetail()
        .then(response => {
          this.data = response.data
          let { provinceId, cityId, districtId, companyLogo} = this.data
          this.data.area = [provinceId, cityId, districtId]
          if(companyLogo){
            this.fileObjs = [{
              isImg: true,
              url: companyLogo
            }]
          }
          if (this.data.specialType === 1) {
            this.listUserWithOutDataScope()
          }
        })
        .catch(error => {
          this.loading = false;
        });
    },
    companyEdit() {
      // 租户类型 1:普通租户 2:SAAS系统管理 3:系统管理 等
      // 传-1的话，服务端会把数据库字段设置为null；非普通租户不需要该字段，传-1即可
      if (this.data.specialType !== 1) {
        this.data.customerServiceUserId = -1
      }
      // if(this.data.area.length){
        this.data.provinceId = this.data.area[0]
        this.data.cityId = this.data.area[1]
        this.data.districtId = this.data.area[2]
      // }
      if(!this.data.companyLogo) {
        this.msgWarning('请上传企业LOGO')
        return
      }
      companyEdit(this.data)
        .then(response => {
          this.msgSuccess('编辑企业信息成功！')
          this.disabled = true
        })
        .catch(error => {
        });
    },
    confirm() {
      this.companyEdit()
    },
    cancel() {
      this.disabled = true
      this.queryCompanyDetail()
    },
    handleFileChange(fileObjs){
      this.fileObjs = fileObjs
      if(fileObjs.length){
        this.data.companyLogo = fileObjs[0].url
      }else {
        this.data.companyLogo = ''
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.logo-img{
  display: inline-block;
  width: 98px;
  height: 98px;
  border-radius: 5px;
  background: #F5F7FA;
  cursor: pointer;
}
</style>
